import { isNative } from './webOnly';

// V8/V9 recs A/B comparison (variant B = previous embedding model) is a dev
// tool: localhost web only. Packaged desktop loads from file:// and Capacitor
// native's WebView origin is `https://localhost` but isNative excludes it.
// Gates BOTH the toggle UI and the variant-B prefetch — keep them in sync so
// prod never pays for a second recommendations call it can't display.
export const isRecsVariantDevEnabled = () =>
    typeof window !== 'undefined'
    && window.location.hostname === 'localhost'
    && !isNative
    && !window.__hideDevToggles;
